module.exports = __webpack_public_path__ + "img/OT663.e0f17a9.jpg";